module.exports = __webpack_public_path__ + "static/normal-people-92c7f115565c409d228031e609b76e8b.jpg";